import { Fragment } from 'react';

import { Box, Divider } from '@mui/material';

import FileItem2 from '../file-item2/FileItem2';
import { FileInfo } from '../multi-file-uploader2/MultiFileUploader2';
import UploadActions from '../upload-actions/UploadActions';

export interface FileUploadedInfoProps {
  fields: FileInfo[];
  canRemoveFiles?: boolean;
  isUploadActive?: boolean;
  onFileRemove?: (id: string) => void;
  onFileRetry?: (id: string) => void;
  isWithDivider?: boolean;
}

export default function FileUploadedInfo2(props: FileUploadedInfoProps) {
  const { fields, onFileRemove, onFileRetry, canRemoveFiles, isWithDivider = true } = props;

  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" mb={2}>
        {fields.map((item) => {
          if (item.state !== 'uploaded') {
            return (
              <Fragment key={item.uppyId || item.id}>
                <UploadActions item={item} onCancel={onFileRemove} onRetry={onFileRetry} />
              </Fragment>
            );
          } else {
            return (
              <Box width="100%" key={item.uppyId || item.id}>
                <FileItem2
                  item={item}
                  remove={onFileRemove}
                  canRemoveFiles={canRemoveFiles}
                  isLoading={!canRemoveFiles ? true : false}
                />
              </Box>
            );
          }
        })}
      </Box>
      {isWithDivider && <Divider />}
    </>
  );
}
